// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"184":"9dc22a25","406":"243f6b37","412":"1724fe71","994":"e1d8d369"}[chunkId] + ".css";
};